import { Button } from '@mui/material';
import { MultiSelector, Selector } from 'components/common';
import { useAppDispatch, useAppSelector } from 'hooks';
import React, { useEffect } from 'react';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import { DataStatus, UserRole } from 'types/enums';
import { UserRoleType } from 'types/types';
import { facilityActions } from 'utils/store';

type Properties<T extends FieldValues> = {
  control: Control<T, null>;
  name: FieldPath<T>;
  role: UserRoleType;
};

export const FacilitySelector = <T extends FieldValues>({ control, name, role }: Properties<T>) => {
  const dispatch = useAppDispatch();
  const { facilities, status } = useAppSelector(({ facility }) => facility);
  const token = useAppSelector(({ user }) => user.token);

  useEffect(() => {
    if (token && !facilities.length) {
      dispatch(facilityActions.getAllFacilities());
    }
  }, [dispatch, facilities.length, token]);

  if (status === DataStatus.LOADING) {
    return <h2>Loading</h2>;
  }

  return (
    <>
      {facilities?.length ? (
        role === UserRole.ADMIN ? (
          <MultiSelector
            label='Choose your facilities'
            values={facilities.map(({ name: label, id }) => ({ label, id }))}
            name={name}
            control={control}
          />
        ) : (
          <Selector
            label={'Choose your facility'}
            values={facilities.map(({ name: label, id }) => ({ label, id }))}
            control={control}
            name={name}
          />
        )
      ) : (
        <h2>No facilities</h2>
      )}
      <Button>Add new facility</Button>
    </>
  );
};
